import useToggleHandler from "@/Hooks/useToggleHandler";
import { useIdle } from "@repo/ui/hooks";
import InactivityModal from "./InactivityModal";

const InactivityWrapper = () => {
  const { isOpen, toggler } = useToggleHandler();
  useIdle({
    time: 1000 * 60 * 15,
    cb: () => {
      toggler();
    },
  });

  if (!isOpen) return null;
  return <InactivityModal isOpen={isOpen} handleClose={toggler} />;
};

export default InactivityWrapper;
